import api from '.'

export const roles = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/roles`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/roles`, null, success, fail)
  },
  update (roleId, data, success, fail) {
    api.authenticatedRequest('PUT', `/roles/${roleId}`, data, success, fail)
  },
  delete (roleId, success, fail) {
    api.authenticatedRequest('DELETE', `/roles/${roleId}`, null, success, fail)
  }
}
